import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/persons/profiles']['PUT'];

type GetPersonResponse = ThisApi['response'];

const searchPersonProfiles = async (body: ThisApi['body']): Promise<GetPersonResponse> => {
  const response = await noodleApiClient.put('/persons/profiles', body);
  return response.data;
};

export default searchPersonProfiles;
